function openVideoBubble(modalId) {
  var modal = document.getElementById(modalId);
  if (!modal) return;

  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  var iframe = modal.querySelector('iframe[data-src]');
  if (iframe) iframe.src = iframe.dataset.src;

  var video = modal.querySelector('video');
  if (video) video.play();

  modal.removeAttribute('hidden');
  modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';

  document.addEventListener('keydown', function escHandler(e) {
    if (e.key === 'Escape') {
      closeVideoBubble(modalId);
      document.removeEventListener('keydown', escHandler);
    }
  }, { once: true });
}

function closeVideoBubble(modalId) {
  var modal = document.getElementById(modalId);
  if (!modal) return;

  var iframe = modal.querySelector('iframe');
  if (iframe) iframe.src = '';

  var video = modal.querySelector('video');
  if (video) {
    video.pause();
    video.currentTime = 0;
  }

  modal.style.display = 'none';
  document.body.style.overflow = '';
}

function initHoverPlay() {
  document.querySelectorAll('.video-bubble[data-preview-src]').forEach(function(btn) {
    var circle = btn.querySelector('.video-bubble__circle');
    var previewVid = null;

    function createPreview() {
      previewVid = document.createElement('video');
      // preload="none" est décisif : sans lui l'élément vaut preload="auto" et
      // le navigateur télécharge la vidéo dès l'ajout au DOM. Ici aucun octet
      // n'est demandé tant que play() n'a pas été appelé.
      previewVid.preload = 'none';
      previewVid.muted = true;
      previewVid.loop = false;
      previewVid.playsInline = true;
      previewVid.setAttribute('aria-hidden', 'true');
      previewVid.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:1;opacity:0;transition:opacity .3s;';
      previewVid.addEventListener('timeupdate', function() {
        if (previewVid.currentTime >= 4) {
          previewVid.currentTime = 0;
          previewVid.play();
        }
      });
      previewVid.src = btn.dataset.previewSrc;
      circle.appendChild(previewVid);
    }

    function startPreview() {
      if (!previewVid) createPreview();
      previewVid.play().then(function() { previewVid.style.opacity = '1'; }).catch(function() {});
    }

    btn.addEventListener('mouseenter', startPreview);

    btn.addEventListener('mouseleave', function() {
      if (previewVid) {
        previewVid.pause();
        previewVid.style.opacity = '0';
      }
    });

    // Aucune lecture automatique, y compris sur la bulle « featured ».
    // L'effet qui attire l'oeil sur celle-ci est l'animation CSS vb-attention
    // (video-bubbles.css) : elle ne coûte pas un octet et tourne sans vidéo.
    // Le MP4 n'est demandé qu'au survol ou au clic.
  });
}

function initAll() {
  initHoverPlay();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}
